import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "geotab-config bordered-box" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Geotab Configuration", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "Service Account Configuration", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, "AccidentPlan Portal Access", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Security Groups ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-info" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "User Syncing", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Sync Users "),
  /*#__PURE__*/_createVNode("i", { class: "el-icon-info" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createVNode(_component_el_form, {
      model: _ctx.form,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_el_form_item, { label: "Database" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.database,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.database = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Username" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.userName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.userName = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Password" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.form.password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.password = $event)),
              "show-password": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _hoisted_4,
        _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_el_tooltip, {
              placement: "right",
              effect: "light",
              content: "These are the Geotab security groups that will be able to access the report-builder portal."
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.form.requiredSecurityClearances,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.requiredSecurityClearances = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allSecurityClearances, (securityGroup) => {
                  return (_openBlock(), _createBlock("div", {
                    key: securityGroup.id
                  }, [
                    _createVNode(_component_el_checkbox, {
                      label: securityGroup.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(securityGroup.name ?? _ctx.defaultSecurityGroupNames[securityGroup.id]), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.saveConfig,
              disabled: _ctx.saveState === _ctx.FetchStates.FETCHING
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]), [
              [_directive_loading, _ctx.saveState === _ctx.FetchStates.FETCHING]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]), [
      [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
    ]),
    _hoisted_8,
    _withDirectives(_createVNode(_component_el_button, {
      type: "primary",
      onClick: _ctx.syncUsers,
      disabled: _ctx.syncState === _ctx.FetchStates.FETCHING
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          placement: "right",
          effect: "light",
          content: "Use this to sync users, user permissions, and user preferences from Geotab to AccidentPlan."
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick", "disabled"]), [
      [_directive_loading, _ctx.syncState === _ctx.FetchStates.FETCHING]
    ])
  ]))
}